import { render, staticRenderFns } from "./research-category.vue?vue&type=template&id=a5823e20&"
import script from "./research-category.vue?vue&type=script&lang=js&"
export * from "./research-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports